module Cfnc {
    "use strict";

    interface ICfncRadio extends angular.IDirective {
        labelText: string;
    }

    interface ICfncRadioScope extends angular.IScope {
        model: any;
        name: string;
        labelText: string;
        ngModel: any;
        ngValue: any;
        ngDisabled: any;
    }

    interface ICfncRadioAttributes extends angular.IAttributes {
        labelText: string;
        trueValue: string;
        falseValue: string;
    }

    class CfncRadio implements ng.IDirective {
        static directiveId: string =  "cfncRadio";
        restrict: string = "E";
        require: string = "?ngModel";
        template: string = `<div class="radio-container no-select cfnc-Radio">
                    <input id="rad{{name || $id}}" name="{{name || $id}}" type="radio" ng-model="model" ng-value="ngValue" ng-disabled="ngDisabled"/>
                    <label for="rad{{name || $id}}" class="input-label" tabindex="0">{{labelText}}</label>
                </div>`;
        replace: boolean = true;
        scope: any = {
            name: "@",
            ngModel: "=",
            labelText: "@",
            ngValue: "=",
            ngDisabled: "="
        };

        constructor() {
        }

        link = (scope: ICfncRadioScope, element: angular.IAugmentedJQuery, attrs: ICfncRadioAttributes, controller: ng.INgModelController) => {

            scope.model = scope.ngModel;

            scope.$watch("model", (newValue, oldValue) => {
                if (newValue != oldValue) {
                    controller.$setViewValue(newValue);
                }
            });

            scope.$watch("ngModel", (newValue, oldValue) => {
                if (newValue != oldValue) {
                    scope.model = newValue;
                }
            });

            element.on("keypress", (event) => {
                if (event.which == 13 || event.which == 32) {
                    event.preventDefault();
                    scope.ngModel = scope.ngValue;
                    scope.$applyAsync();
                }
            });


        }
    }

    angular.module("app").directive(CfncRadio.directiveId, [() => new CfncRadio()]);
}

/*
 cfnc-radio Usage
 <cfnc-radio 
    ng-model="model" 
    label-text="label text"
    on-change="func()"></cfnc-radio>

    ng-model: expression
    label-text: expression | string
 */ 